import React, { useState, useEffect } from 'react';
import { useParams, Link as RouterLink, useNavigate } from 'react-router-dom';

import {
  makeStyles,
  Typography,
  Card,
  Box,
  Container,
  Link,
  Button
} from '@material-ui/core';

import Page from 'src/shared/ui/components/Page';
import Form from 'src/shared/ui/components/Form';
import processFormErrorMessages from 'src/shared/ui/components/Form/FormErrorMessage';

import validateSchema from 'src/shared/models/SchemaValidator';
import Stamp from 'src/stamp/models/Stamp';

import createStamp from 'src/stamp/use-cases/createStamp';
import updateStampById from 'src/stamp/use-cases/updateStampById';
import getStampById from 'src/stamp/use-cases/getStampById';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  saveButton: {
    top: '-20px'
  },
  backButton: {
    top: '-20px',
    marginRight: theme.spacing(1)
  },
  scrollBox: {
    overflow: 'scroll',
    height: '80vh'
  }
}));

const StampFormView = () => {
  const classes = useStyles();
  const [formFields, setFormFields] = useState([]);
  const [isRequesting, setIsRequesting] = useState(false);
  const { stampId } = useParams();
  const navigate = useNavigate();

  const initFormFields = async (fields) => {
    const stamp = Stamp({
      fields,
      userHeadquarterList: JSON.parse(localStorage.userHeadquarterList),
      selectedUserHeadquarter: localStorage.selectedUserHeadquarter
    });

    setFormFields(stamp);
  };

  const fetchForm = async () => {
    const stamp = await getStampById(stampId);

    initFormFields(stamp);
  };

  useEffect(() => {
    if (stampId === 'new') {
      initFormFields();
    } else {
      fetchForm();
    }
  }, []);

  const validateFormFields = async (formFieldsValues) => {
    const validatedFormFields = await validateSchema(formFieldsValues);
    formFieldsValues = processFormErrorMessages(
      validatedFormFields,
      formFieldsValues
    );
    setFormFields(formFieldsValues.fields);

    return {
      errors: formFieldsValues.errors,
      fields: validatedFormFields
    };
  };

  const handleChangeFormFieldsValues = (formFieldsValues) => {
    setFormFields(formFieldsValues);
  };

  const postForm = async () => {
    if (isRequesting) {
      return;
    }

    const validatedForm = await validateFormFields(formFields);
    if (validatedForm.errors) {
      alert('Rellene todos los campos correctamente.');
      return;
    }

    setIsRequesting(true);

    let result;
    if (stampId === 'new') {
      result = await createStamp(validatedForm.fields);
    } else {
      result = await updateStampById(validatedForm.fields, stampId);
    }

    setIsRequesting(false);

    if (typeof result.id === 'undefined') {
      alert('Se ha producido un error, vuelva a intentarlo');
    } else {
      navigate('/app/stamps');
    }
  };

  return (
    <Page className={classes.root} title="Timbrados">
      <Container maxWidth={false}>
        <Box className={classes.navigation} display="flex">
          <Typography color="textSecondary" variant="body2">
            <Link component={RouterLink} to="/app/stamps">
              Timbrados
            </Link>
            {` >  ${
              formFields.length && formFields[1].value.length
                ? formFields[1].value
                : 'Nuevo'
            }`}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="flex-end">
          <Link component={RouterLink} to="/app/stamps">
            <Button className={classes.backButton}>{'Volver a listado'}</Button>
          </Link>
          <Button
            color="primary"
            variant="contained"
            className={classes.saveButton}
            onClick={postForm}
          >
            Guardar
          </Button>
        </Box>
        <Card>
          <Form
            fields={formFields}
            onChangeFields={handleChangeFormFieldsValues}
          />
        </Card>
      </Container>
    </Page>
  );
};

export default StampFormView;
